import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { VideoRequestsService } from '../../services/video-requests/video-requests.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
var VideoRequestsComponent = /** @class */ (function () {
    function VideoRequestsComponent(flashMessagesService, activatedRoute, router, returnUrlService, videoRequestsService) {
        this.flashMessagesService = flashMessagesService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.returnUrlService = returnUrlService;
        this.videoRequestsService = videoRequestsService;
        this.messageIds = {
            newRequest: null
        };
        this.returnUrlService.save();
    }
    VideoRequestsComponent.prototype.ngOnDestroy = function () {
        this.flashMessagesService.clear(this.messageIds.newRequest);
    };
    VideoRequestsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, vrrIdString, request, name_1, preface;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.videoRequestsService.all()];
                    case 1:
                        _a.requests = _b.sent();
                        vrrIdString = this.activatedRoute.snapshot.paramMap.get('vrrId');
                        if (vrrIdString) {
                            this.newVrrId = parseInt(vrrIdString, 10);
                            request = this.requests.find(function (value) { return value.vrrId === _this.newVrrId; });
                            if (request) {
                                name_1 = request.requestName + (request.requestName.endsWith('.') ? '' : '.');
                                preface = 'Video request submitted successfully:';
                                this.messageIds.newRequest = this.flashMessagesService.addMessage(Severity.Success, name_1, preface);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoRequestsComponent.prototype.showDetails = function (request) {
        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(['video-request', request.requestId]);
    };
    return VideoRequestsComponent;
}());
export { VideoRequestsComponent };
